import icon from "../../_assets/img/disk.png";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import Aggrement from "../Steps/Aggrement";

const FromMemory = () => {
  const history = useHistory();
  //const [agreement, setAgreement] = useState<boolean | undefined>(undefined);

  // const answer = (e: any) => {
  //   e.preventDefault();
  //   setAgreement(false)
  // }

  // useEffect(() => {
  //   if (agreement)
  //     createDeclaration();
  // }, [agreement])

  const createDeclaration = () => {
    localStorage.removeItem("agreement");
    history.push({
      pathname: "/step1",
      state: { new: true, fromLocalStorage: true },
    });
    localStorage.setItem("type", "memory");
  };

  return (
    <>

      <div className="col-12">
        <a href="" onClick={(e) => createDeclaration()}>
          <div className="card option" onClick={(e) => createDeclaration()}>
            <div className="row">
              <div className="col-2 d-flex justify-content-around imgCard imgCardL">
                <img src={icon} alt="Zostanie przywrócona deklaracja z pamięci komputera" />
              </div>
              <div className="col-10 imgCardR">
                <div className="secendaryHeader">
                  <div className="TitleCategory">Przywróć ostatnią</div>
                </div>
                <p className="card-text">
                  Przywróć zapamiętany stan formularza z ostatniej sesji.
                </p>
              </div>
            </div>
          </div>
        </a>
      </div>
      {/* {!agreement ? <Aggrement agreement={agreement ?? true} setAgreement={setAgreement} /> : null} */}
    </>
  );
};

export { FromMemory };
